export default __webpack_public_path__ + "static/media/404_page.34beeec2.png";